import { render, staticRenderFns } from "./addenMaterial.vue?vue&type=template&id=6ea02bf6&scoped=true"
import script from "./addenMaterial.vue?vue&type=script&lang=js"
export * from "./addenMaterial.vue?vue&type=script&lang=js"
import style0 from "./addenMaterial.vue?vue&type=style&index=0&id=6ea02bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea02bf6",
  null
  
)

export default component.exports